// ** React Imports
import { useRef, useCallback } from "react";

// ** Redux & Store & Actions
import { useSelector, useDispatch } from "react-redux";
import { getPosts } from "store/modules/main-pages/posts/get-posts.action";

// #####################################################

const usePostsInfinityScroll = ({ containerRef }) => {
	const dispatch = useDispatch();

	const isAuth = useSelector((state) => state.globalCommon.isAuth);

	const isLoading = useSelector((state) => state.mainPagePosts.loading);
	const currentPage = useSelector(
		(state) => state.mainPagePosts.pagination.currentpage
	);
	const totalPages = useSelector(
		(state) => state.mainPagePosts.pagination.totalpages
	);

	const initialMarginValue = useRef(null);
	const triggerObserver = useRef();
	const triggerRef = useCallback(
		(node) => {
			if (isLoading || !("IntersectionObserver" in window)) return;
			if (currentPage >= totalPages) return null;
			if (triggerObserver.current) triggerObserver.current.disconnect();

			setTimeout(() => {
				if (initialMarginValue.current === null) {
					initialMarginValue.current =
						containerRef.current?.getBoundingClientRect().height ||
						600;
				}
				const finalMarginValue = Math.round(
					initialMarginValue.current * (currentPage <= 10 ? 0.2 : 0.3)
				);

				triggerObserver.current = new IntersectionObserver(
					(entries) => {
						if (entries.some((entry) => entry.isIntersecting)) {
							dispatch(
								getPosts({
									params: {
										page: currentPage + 1,
									},
									infinityScroll: true,
									isAuth,
								})
							);
						}
					},
					{
						rootMargin: `0px 0px ${finalMarginValue}px 0px`,
					}
				);
				if (node) triggerObserver.current.observe(node);
			}, 0);
		},
		[currentPage, totalPages, isLoading]
	);

	// #####################################################

	return {
		triggerRef,
	};
};

// #####################################################

export default usePostsInfinityScroll;

// #####################################################
